import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-one-input',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './modal-one-input.component.html',
  styleUrl: './modal-one-input.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalOneInputComponent {
  protected email: FormControl = new FormControl('', [Validators.required, Validators.email]);
  @Output() saveEmail: EventEmitter<string> = new EventEmitter();
  dataModal: any;
  readonly nzModalData = inject(NZ_MODAL_DATA);

  constructor(private activeModal: NzModalRef) {}

  protected close() {
    this.activeModal.close();
  }

  protected save() {
    if (this.email.value) {
      this.nzModalData?.saveEmail(this.email.value);
    }
  }
}
